export const settingsMetadata = [
    {
        autoInclude: true,
        communityType: "Continuing Care Retirement Community",
        order: 1000,
        pricing: "none",
    },
    {
        autoInclude: true,
        communityType: "Independent Living",
        floorplans: ["Studio", "One Bedroom", "One Bedroom Plus", "Two Bedroom"],
        order: 2000,
        pricing: "perFloorplan",
    },
    {
        autoInclude: true,
        communityType: "Assisted Living",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 3000,
        pricing: "perFloorplan",
        states: [
            "CA",
            "FL",
            "OR",
            "VA",
            "TX",
            "CT",
            "WA",
            "KS",
            "NV",
            "OH",
            "IN",
            "KY",
            "GA",
            "WI",
            "IL",
            "TN",
            "OK",
            "MN",
            "PA",
            "MA",
            "NH",
            "NJ",
            "NC",
            "AL",
        ],
    },
    {
        autoInclude: true,
        communityType: "Assisted Living",
        floorplans: [
            "Private Room",
            "Semi-Private Room",
            "Triple Room",
            "One Bedroom",
            "One Bedroom Plus",
            "Two Bedroom",
        ],
        order: 3000,
        pricing: "perFloorplan",
        states: ["MD"],
    },
    {
        autoInclude: false,
        communityType: "Assisted Living Center",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 3000,
        pricing: "perFloorplan",
        states: ["AZ"],
    },
    {
        autoInclude: true,
        communityType: "Large Assisted Living",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 3000,
        pricing: "perFloorplan",
        states: ["CO"],
    },
    {
        autoInclude: true,
        communityType: "Small Group Home",
        floorplans: ["NEEDS_TO_BE_SET"],
        order: 3000,
        pricing: "perFloorplan",
        states: ["MI"],
    },
    {
        autoInclude: true,
        communityType: "Assisted Living 1",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 3100,
        pricing: "perFloorplan",
        states: ["MO", "AR"],
    },
    {
        autoInclude: true,
        communityType: "Assisted Living 2",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 3200,
        pricing: "perFloorplan",
        states: ["MO", "AR"],
    },
    {
        autoInclude: true,
        communityType: "Medium Group Home",
        floorplans: ["NEEDS_TO_BE_SET"],
        order: 3200,
        pricing: "perFloorplan",
        states: ["MI"],
    },
    {
        autoInclude: true,
        communityType: "Large Group Home",
        floorplans: ["NEEDS_TO_BE_SET"],
        order: 3400,
        pricing: "perFloorplan",
        states: ["MI"],
    },
    {
        autoInclude: true,
        communityType: "Small Assisted Living",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["CO"],
    },
    {
        autoInclude: true,
        communityType: "Personal Care Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["TX", "OH", "IN", "KY", "GA", "PA"],
    },
    {
        autoInclude: false,
        communityType: "Adult Family Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["MI", "WA", "NV", "OH", "IN", "KY", "IL", "WI", "MN"],
    },
    {
        autoInclude: false,
        communityType: "Family Care Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["FL", "NC", "OH", "IN", "KY"],
    },
    {
        autoInclude: false,
        communityType: "Assisted Living Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["AZ"],
    },
    {
        autoInclude: true,
        communityType: "Boarding Care Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["KS"],
    },
    {
        autoInclude: true,
        communityType: "Residential Care Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["CA", "CT", "OK", "MN", "NH", "NJ"],
    },
    {
        autoInclude: true,
        communityType: "Residential Care Apartment Complex",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["WI"],
    },
    {
        autoInclude: true,
        communityType: "Adult Care Home",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["OR", "MO", "TN"],
    },
    {
        autoInclude: true,
        communityType: "Home Plus",
        floorplans: ["Shared", "Private"],
        order: 4100,
        pricing: "perFloorplan",
        states: ["KS"],
    },
    {
        autoInclude: false,
        communityType: "Rehabilitation Facilities",
        floorplans: ["Shared", "Private"],
        order: 4200,
        pricing: "perFloorplan",
        states: ["TN"],
    },
    {
        autoInclude: false,
        communityType: "Home For The Aged",
        floorplans: ["Shared", "Private"],
        order: 4200,
        pricing: "perFloorplan",
        states: ["MI", "TN"],
    },
    {
        autoInclude: false,
        communityType: "Congregate",
        floorplans: ["NEEDS_TO_BE_SET"],
        order: 4500,
        pricing: "perFloorplan",
        states: ["MI"],
    },
    {
        autoInclude: true,
        communityType: "Residential Care",
        floorplans: ["Shared", "Private"],
        order: 4500,
        pricing: "perFloorplan",
        states: ["OR", "NV"],
    },
    {
        autoInclude: true,
        communityType: "Residential Care Facility",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 4500,
        pricing: "perFloorplan",
        states: ["MO", "AR", "KS"],
    },
    {
        autoInclude: true,
        communityType: "Residential Health Care Facility",
        floorplans: ["Shared", "Private", "Studio", "One Bedroom"],
        order: 4600,
        pricing: "perFloorplan",
        states: ["KS", "NJ"],
    },
    {
        autoInclude: false,
        communityType: "Community Living Arrangement",
        floorplans: ["Shared", "Private"],
        order: 4500,
        pricing: "perFloorplan",
        states: ["GA"],
    },
    {
        autoInclude: false,
        communityType: "Skilled Nursing",
        floorplans: ["Private Room", "Semi-Private Room", "Triple Room", "Quad Room"],
        order: 6000,
        pricing: "perFloorplan",
        states: ["MD"],
    },
    {
        autoInclude: false,
        communityType: "Memory Care Assisted Living",
        floorplans: ["Shared", "Private"],
        order: 4000,
        pricing: "perFloorplan",
        states: ["OH"],
    },
    {
        autoInclude: true,
        communityType: "Memory Care",
        floorplans: ["Shared", "Private"],
        order: 5000,
        pricing: "perFloorplan",
    },
    {
        autoInclude: true,
        communityType: "Assisted Living Program",
        order: 10100,
        pricing: "general",
        states: ["NJ"],
    },
    {
        autoInclude: false,
        communityType: "Skilled Nursing",
        floorplans: ["Shared", "Private"],
        order: 6000,
        pricing: "perFloorplan",
        states: [
            "AZ",
            "CA",
            "FL",
            "OR",
            "CO",
            "VA",
            "MI",
            "TX",
            "CT",
            "WA",
            "MO",
            "KS",
            "AR",
            "NV",
            "OH",
            "IN",
            "KY",
            "TN",
            "OK",
            "MN",
            "PA",
            "GA",
            "WI",
            "MA",
            "NH",
            "NJ",
            "NC",
            "AL",
        ],
    },
    {
        autoInclude: false,
        communityType: "Memory Care Nursing",
        floorplans: ["Shared", "Private"],
        order: 6200,
        pricing: "perFloorplan",
        states: ["OH"],
    },
    {
        autoInclude: false,
        communityType: "Intermediate Care Facility",
        floorplans: ["Shared", "Private"],
        order: 6200,
        pricing: "perFloorplan",
        states: ["MO", "NV"],
    },
    {
        autoInclude: false,
        communityType: "Infirmary",
        order: 7000,
        pricing: "general",
        states: ["MI"],
    },
    {
        autoInclude: false,
        communityType: "Adult Foster Care",
        floorplans: ["Shared", "Private"],
        order: 8000,
        pricing: "perFloorplan",
        states: ["AZ"],
    },
    {
        autoInclude: false,
        communityType: "Residential Behavioral Health",
        floorplans: ["Shared", "Private"],
        order: 9000,
        pricing: "perFloorplan",
        states: ["AZ"],
    },
    {
        autoInclude: false,
        communityType: "Gero Psych",
        order: 9500,
        pricing: "general",
        states: ["AZ"],
    },
    {
        autoInclude: false,
        communityType: "Adult Day Care",
        order: 10100,
        pricing: "general",
        states: [
            "FL",
            "TX",
            "KS",
            "AR",
            "NV",
            "OH",
            "IN",
            "KY",
            "WI",
            "IL",
            "OK",
            "MA",
            "NJ",
        ],
    },
    {
        autoInclude: false,
        communityType: "Adult Day Health Care",
        order: 12000,
        pricing: "general",
        states: ["AZ"],
    },
    {
        autoInclude: false,
        communityType: "Personal Assistance Services",
        order: 13900,
        pricing: "general",
        states: ["TX"],
    },
    {
        autoInclude: false,
        communityType: "In-Home Care",
        order: 14000,
        pricing: "general",
    },
    {
        autoInclude: false,
        communityType: "MediCal-ALW",
        order: 14500,
        pricing: "general",
        states: ["CA"],
    },
    {
        autoInclude: false,
        communityType: "Private Duty Home Care",
        order: 15000,
        pricing: "general",
        states: ["MO"],
    },
    {
        autoInclude: false,
        communityType: "Home Health",
        order: 16000,
        pricing: "general",
    },
    {
        autoInclude: false,
        communityType: "Hospice",
        order: 30500,
        pricing: "general",
    },
    {
        autoInclude: false,
        communityType: "Respite Care",
        order: 32000,
        pricing: "general",
    },
    {
        autoInclude: false,
        communityType: "Rehab",
        order: 33000,
        pricing: "general",
        states: ["MO"],
    },
];
//# sourceMappingURL=metadata.js.map